import { jsx as _jsx } from "react/jsx-runtime";
import { x } from '@xstyled/styled-components';
import { PoweredBy } from '../icons/powered-by';
export var PoweredByLogo = function PoweredByLogo(props) {
  return /*#__PURE__*/_jsx(x.div, {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    w: "100%",
    flexDirection: "column",
    children: /*#__PURE__*/_jsx(x.a, {
      cursor: "pointer",
      href: props.customHref,
      target: "__blank",
      rel: "noopener noreferrer",
      alignSelf: "center",
      "data-testid": "icon-powered-by",
      children: /*#__PURE__*/_jsx(PoweredBy, {})
    })
  });
};
PoweredByLogo.defaultProps = {
  customHref: 'https://after.sale/entregas/'
};